import React from "react";
import GlobalTextInputField from "../../components/GlobalTextInputField";
import type { StepSignatureState } from "../../types/types";
import Warning from "../../assets/warning.svg";

type Props = {
    value: StepSignatureState;
    onChange: (patch: Partial<StepSignatureState>) => void;
};

const Label: React.FC<React.PropsWithChildren> = ({ children }) => (
    <label className="text-[10px] font-semibold text-text-base">{children}</label>
);

const ApplicantConfirmationSignatureStep: React.FC<Props> = ({ value, onChange }) => {
    return (
        <div className="space-y-4">
            {/* small header */}

            <p className="text-text-base text-[10px]">I CONFIRM THAT I AM AUTHORIZED TO PROVIDE THIS INFORMATION ON BEHALF OF THE COMPANY. I CONFIRM THE ACCURACY OF THE INFORMATION PROVIDED ABOVE.</p>

            <div className="grid grid-cols-2 gap-4">
                <GlobalTextInputField
                    title="NAME"
                    value={value.name}
                    onChange={(e: any) => onChange({ name: e.target.value })}
                    placeholder="Enter your full name"
                    showBorder
                />

                <GlobalTextInputField
                    title="TITLE"
                    value={value.title}
                    onChange={(e: any) => onChange({ title: e.target.value })}
                    placeholder="e.g. Director, Authorized Signatory"
                    showBorder
                />

                <GlobalTextInputField
                    title="DATE"
                    type="date"
                    value={value.date}
                    onChange={(e: any) => onChange({ date: e.target.value })}
                    showBorder
                />

            </div>

            {/* optional acknowledgement text */}
            <p className="text-[12px] text-text-base">
                By submitting, I confirm the information provided is true and complete to the best of my knowledge.
            </p>
            <p className="text-[12px] text-text-base flex items-center gap-1 bg-bg-base p-2 w-auto rounded-xl">
                <img src={Warning} alt="" className="w-4 h-4" />Once you submit the KYB form, no further edits will be allowed. Please review all details carefully before clicking Submit.
            </p>
        </div>
    );
};

export default ApplicantConfirmationSignatureStep;
